import { Star } from "lucide-react";

export default function ReviewsSummary({ stats }) {
  if (!stats) return null;
  const { moyenne, total, distribution } = stats;

  return (
    <div className="text-center mb-10" data-testid="reviews-summary">
      <div className="flex items-center justify-center gap-3 mb-2">
        <span className="text-4xl sm:text-5xl font-bold text-[#062133] tracking-tight">{moyenne.toFixed(1)}</span>
        <div className="flex gap-0.5">
          {[1, 2, 3, 4, 5].map(i => (
            <Star key={i} size={22} className="text-amber-400 fill-amber-400" />
          ))}
        </div>
      </div>
      <p className="text-[#062133]/50 text-sm">
        Basé sur <strong className="text-[#062133]/80">{total}</strong> avis Google vérifiés
      </p>
      <div className="max-w-[240px] mx-auto mt-5 space-y-1.5">
        {[5, 4, 3, 2, 1].map(note => {
          const count = (distribution && distribution[note]) || 0;
          const pct = total > 0 ? (count / total) * 100 : 0;
          return (
            <div key={note} className="flex items-center gap-2 text-xs">
              <span className="w-3 text-[#062133]/60 font-medium">{note}</span>
              <Star size={11} className="text-amber-400 fill-amber-400 shrink-0" />
              <div className="flex-1 h-1.5 bg-[#062133]/5 rounded-full overflow-hidden">
                <div className="h-full bg-amber-400 rounded-full transition-all" style={{ width: `${pct}%` }} />
              </div>
              <span className="w-5 text-right text-[#062133]/40">{count}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
